<template>
  <ForieLoader v-show="showLoader && this.$store.state.domainSystemX == 1" />
  <TeLoader v-show="showLoader && this.$store.state.domainSystemX == 2" />

  <div class="mt-2 container">
    <div class="row">
      <div v-show="hasFilterItems" class="col-md-3">
        <div class="card bg-dark text-white">
          <div class="card-header">
            {{ this.$store.getters.getWordLocale("txt_filterleme") }}
          </div>
          <div class="card-body">
            <div v-show="hasCategory">
              <label class="form-label">
                {{ this.$store.getters.getWordLocale("txt_kategori") }}</label
              >
              <Select2
                :options="mainCategories"
                v-model="selectedMainCategory"
                @select="setSelectedMainCategory($event.id)"
              />

              <label v-show="selectedMainCategory > 0" class="form-label mt-2">
                {{
                  this.$store.getters.getWordLocale("txt_alt_katrgori")
                }}</label
              >
              <Select2
                v-show="selectedMainCategory > 0"
                :options="subCategories"
                @select="setSelectedSubCategory($event.id)"
              />
              <hr />
            </div>

            <div v-show="hasKeywords">
              <label class="form-label mt-2">
                {{ this.$store.getters.getWordLocale("txt_ara") }}</label
              >
              <input
                v-model="searchText"
                type="text"
                class="form-control"
                :placeholder="
                  this.$store.getters.getWordLocale(
                    'txt_anahtar_kelime_ile_ara'
                  )
                "
              />

              <hr />
            </div>

            <div v-show="hasCountry">
              <label class="form-label mt-2">
                {{ this.$store.getters.getWordLocale("txt_ulke") }}</label
              >
              <Select2
                :options="countries"
                v-model="selectedCountry"
                @select="setSelectedCountry($event.id)"
              />
            </div>

            <hr />
            <div v-show="hasLeadTypes">
              <label class="form-label mt-2">
                {{ this.$store.getters.getWordLocale("txt_talep_tipi") }}</label
              >
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="businessSegment"
                  id="allTypes"
                  v-on:change="setSelectedLeadType(-1)"
                  :checked="selectedLeadType == -1"
                />
                <label class="form-check-label" for="allTypes">
                  {{ this.$store.getters.getWordLocale("txt_tumu") }}
                </label>
              </div>

              <div
                v-for="(type, index) in leadTypes"
                :key="index"
                class="form-check"
                v-show="
                  selectedLeadTypes.indexOf(type.id) !== -1 ||
                  selectedLeadTypes.length == 0
                "
              >
                <input
                  class="form-check-input"
                  type="radio"
                  name="businessSegment"
                  :id="'type-' + index"
                  v-on:change="setSelectedLeadType(type.id)"
                  :checked="selectedLeadType == type.id"
                />
                <label class="form-check-label" :for="'type-' + index">
                  {{ type.label }}
                </label>
              </div>
            </div>

            <div class="mt-4" v-show="hasFilterItems">
              <button
                v-on:click="getLeadsList(0)"
                type="button"
                class="float-end btn btn-dark btn-sm"
              >
                {{ this.$store.getters.getWordLocale("txt_ara") }}
              </button>
              <button
                type="button"
                v-on:click="clearFilters"
                class="float-end btn btn-danger btn-sm me-2"
              >
                {{ this.$store.getters.getWordLocale("txt_sifirla") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div :class="hasFilterItems == true ? 'col-md-9' : 'col-md-12'">
        <div class="card bg-dark text-white">
          <div class="card-header">Talep Listesi</div>
          <div class="card-body">
            <div
              class="card bg-dark text-white mb-2 p-1 lead-card"
              v-for="(lead, index) in leadListData"
              :key="index"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="lead-country">
                    <div class="row">
                      <div class="col-md-1">
                        <country-flag
                          class="me-0"
                          :country="lead.countryCode"
                          size="normal"
                        />
                      </div>
                      <div class="col-md-9 mt-2 p-0">
                        <router-link
                          :to="
                            '/' +
                            this.$store.state.langCodeX +
                            '/lead/' +
                            lead.link
                          "
                          ><b> {{ lead.title }} </b></router-link
                        >
                      </div>
                      <div class="col-md-2">
                        <small
                          class="float-end lead-time badge bg-white text-dark"
                        >
                          {{ lead.createTime }}
                        </small>
                      </div>
                    </div>
                  </div>
                  <div class="lead-description mt-3 ms-3">
                    <WordHighlighter
                      :query="this.$store.state.searchInputValueX"
                    >
                      {{ lead.summary }}
                    </WordHighlighter>
                  </div>
                  <div
                    v-show="lead.keywords.filter((q) => q != '').length > 0"
                    class="lead-keywords ms-3 mt-2"
                  >
                    <WordHighlighter
                      v-for="(keyword, i) in lead.keywords"
                      :key="i"
                      :query="this.$store.state.searchInputValueX"
                    >
                      {{ keyword }}
                    </WordHighlighter>
                  </div>

                  <div class="lead-info ms-2 mt-3 d-flex">
                    <div class="lead-type mt-2 ms-2">
                      <small :class="lead.leadType == 0 ? 'buy' : 'sell'">
                        {{
                          lead.leadType == 0
                            ? this.$store.getters.getWordLocale(
                                "txt_alim_talebi"
                              )
                            : lead.leadType == 1
                            ? this.$store.getters.getWordLocale(
                                "txt_satis_teklifi"
                              )
                            : this.$store.getters.getWordLocale("txt_isbirligi")
                        }}
                      </small>
                    </div>
                    <div class="separator"></div>
                    <div v-if="lead.credit > 0" class="lead-credit not-free">
                      <i class="fas fa-coins"></i> {{ lead.credit }}
                    </div>
                    <div v-else class="lead-credit free">
                      <i class="fas fa-handshake"></i>
                      {{ this.$store.getters.getWordLocale("txt_ucretsiz") }}
                    </div>
                    <div class="separator"></div>
                    <div class="lead-country d-flex">
                      <country-flag :country="lead.countryCode" size="small" />
                      <small>{{ lead.countryName }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button
              v-show="noMoreLeads == false"
              v-on:click="getLeadsList(currentPage + 1)"
              class="btn w-100 btn btn-outline-warning mt-2 btn-lg"
            >
              {{ this.$store.getters.getWordLocale("txt_daha_fazla_yukle") }}
            </button>

            <div v-show="noMoreLeads" class="alert alert-info" role="alert">
              <h4 class="alert-heading">
                <i class="fa fa-info-c1ircle"></i>
                {{
                  this.$store.getters.getWordLocale("txt_simdilik_bu_kadar")
                }}!
              </h4>
              <p>
                {{
                  this.$store.getters.getWordLocale(
                    "txt_sitemizin_talep_listesi_surekli_guncelleniyor"
                  )
                }}
              </p>
              <hr />
              <p class="mb-0">
                {{ this.$store.getters.getWordLocale("txt_takipte_kalın") }}
                <i class="fa fa-smile-wink"></i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "./helper.js";
import Select2 from "vue3-select2-component";

import CountryFlag from "vue-country-flag-next";
import moment from "moment";
import { mapState } from "vuex";

import WordHighlighter from "vue-word-highlighter";

import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";

export default {
  computed: mapState({
    isSearchChangedX: (state) => state.isSearchChangedX,
    langCodeX: (state) => state.langCodeX,
  }),
  watch: {
    isSearchChangedX(newVal) {
      if (newVal == true) {
        this.searchText = this.$store.state.searchInputValueX;
        this.getLeadsList(0);
      }
    },
    langCodeX() {
      this.getLeadsList(0);
      this.reBuildMainCategories();
      this.reBuildSubCategories();
      this.reBuildCountries();

      this.leadTypes = [
        { id: 0, label: this.$store.getters.getWordLocale("txt_alim_talebi") },
        {
          id: 1,
          label: this.$store.getters.getWordLocale("txt_satis_teklifi"),
        },
        { id: 2, label: this.$store.getters.getWordLocale("txt_isbirligi") },
      ];
    },
  },
  props: ["leadContent"],
  data() {
    return {
      showLoader: true,
      selectedLeadTypes: [],
      countriesFullData: [],
      mainCategoriesFullData: [],
      subCategoriesFullData: [],
      leadTypes: [
        { id: 0, label: this.$store.getters.getWordLocale("txt_alim_talebi") },
        {
          id: 1,
          label: this.$store.getters.getWordLocale("txt_satis_teklifi"),
        },
        { id: 2, label: this.$store.getters.getWordLocale("txt_isbirligi") },
      ],
      selectedMainAndSubCategories: [],
      leadListData: [],
      noMoreLeads: false,
      selectedCountries: [],
      selectedLeads: [],
      selectedCategories: [],
      keywords: [],
      currentPage: 0,
      skipValueLeads: 0,
      searchText: "",
      hasFilterItems: false,
      selectedMainCategory: 0,
      selectedSubCategory: 0,
      selectedCountry: 0,
      mainCategories: [],
      subCategories: [],
      countries: [],
      hasCategory: false,
      hasKeywords: false,
      hasCountry: false,
      hasLeadTypes: false,
      selectedLeadType: -1,
    };
  },
  components: {
    ForieLoader,
    TeLoader,
    Select2,
    CountryFlag,
    WordHighlighter,
  },
  methods: {
    currentDateTime() {
      return moment().format("MMMM Do YYYY, h:mm:ss a");
    },
    async getMainCategories() {
      var temp = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getMainCategories`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (temp = data))
        .catch((err) => console.log(err.message));

      this.mainCategoriesFullData = temp;

      temp.forEach((element) => {
        var mainCategoryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;
        if (this.selectedMainAndSubCategories.length > 0) {
          if (
            this.selectedMainAndSubCategories.filter(
              (q) => q.mainCategoryId == mainCategoryId
            ).length > 0
          ) {
            this.mainCategories.push({
              text: name,
              id: mainCategoryId,
            });
          }
        } else {
          this.mainCategories.push({
            text: name,
            id: mainCategoryId,
          });
        }
      });

      this.mainCategories.unshift({
        text: this.$store.getters.getWordLocale("txt_tumu"),
        id: 0,
      });
    },
    async getSubCategories() {
      if (this.selectedMainCategory == 0) {
        this.subCategories = [];
        return;
      }
      var mainIdList = [];
      mainIdList.push(this.selectedMainCategory);
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getSubCategories`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            categoryIdList: mainIdList,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.subCategories = data))
        .catch((err) => console.log(err.message));

      this.subCategoriesFullData = this.subCategories;
      var tempList = [];
      this.subCategories.forEach((element) => {
        var subCategoryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;

        if (this.selectedMainAndSubCategories.length > 0) {
          if (
            this.selectedMainAndSubCategories.filter(
              (q) => q.categoryId == subCategoryId
            ).length > 0
          ) {
            tempList.push({
              text: name,
              id: subCategoryId,
            });
          }
        } else {
          tempList.push({
            text: name,
            id: subCategoryId,
          });
        }
      });
      this.subCategories = [];
      this.subCategories = tempList;
    },
    async getCountries() {
      var tempList = [];

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCountries`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (tempList = data))
        .catch((err) => console.log(err.message));

      this.countriesFullData = tempList;

      tempList.forEach((element) => {
        var countryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        if (this.selectedCountries.length > 0) {
          if (this.selectedCountries.indexOf(countryId) !== -1) {
            this.countries.push({
              text: name,
              id: parseInt(element._id),
              flag: element.Flag,
            });
          }
        } else {
          this.countries.push({
            text: name,
            id: parseInt(element._id),
            flag: element.Flag,
          });
        }
      });

      this.countries.unshift({
        text: this.$store.getters.getWordLocale("txt_tum_ulkeler"),
        id: 0,
        flag: "",
      });
    },
    async getLeadsList(page) {
      this.showLoader = true;

      this.currentPage = page;
      if (this.currentPage == 0) {
        this.leadListData = [];
        this.skipValueLeads = 0;
      } else {
        this.skipValueLeads = this.currentPage * 20;
      }
      if (this.searchText != "") {
        this.$store.state.searchInputValueX = this.searchText;
      } else {
        this.$store.state.searchInputValueX = "";
      }
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getLeadsListForDomains`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            domainSystem: this.$store.state.domainSystemX,
            selectedLeadType:
              this.selectedLeadType == -1 ? null : this.selectedLeadType,
            keywords: this.keywords.length == 0 ? null : this.keywords,
            selectedCategories:
              this.selectedSubCategory > 0
                ? [this.selectedSubCategory]
                : this.selectedCategories.length == 0
                ? null
                : this.selectedCategories,
            selectedMainCategories:
              this.selectedMainCategory > 0
                ? [this.selectedMainCategory]
                : null,
            selectedLeads:
              this.selectedLeads.length == 0 ? null : this.selectedLeads,
            selectedCountries:
              this.selectedCountry > 0
                ? [this.selectedCountry]
                : this.selectedCountries.length == 0
                ? null
                : this.selectedCountries,
            search: this.$store.state.searchInputValueX,
            page: this.skipValueLeads,
            selectedLeadTypes: this.selectedLeadTypes,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.leadsList = data))
        .catch((err) => console.log(err.message));

      if (this.leadsList.length < 20) {
        this.noMoreLeads = true;
      } else {
        this.noMoreLeads = false;
      }

      this.leadsList.forEach((element) => {
        var leadTitle =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Title
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Title;

        const dateObject = new Date(
          element.PublishTime
        );
        var createTime = dateObject.toLocaleString("tr-TR");

        var endDate = moment(new Date()).format("DD.MM.YYYY HH:mm:ss");
        endDate = moment(endDate, "DD.MM.YYYY HH:mm:ss");
        createTime = moment(createTime, "DD.MM.YYYY HH:mm:ss");

        var diff = endDate.diff(createTime, "days");
        if (diff == 0) {
          createTime = moment(createTime, "DD.MM.YYYY HH:mm:ss").fromNow();
        } else {
          createTime = dateObject.toLocaleString("tr-TR");
        }

        var leadId = parseInt(element._id);
        var leadType = parseInt(element.Type);
        var credit = parseInt(element.Credit);
        var countryName =
          element.Country.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length == 0
            ? element.Country.filter((q) => q.LangCode == "en").length == 0
              ? element.Country.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name
              : element.Country.filter((q) => q.LangCode == "en")[0].Name
            : element.Country.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name;
        var countryCode =
          element.Country[0] != null && element.Country[0] != undefined
            ? element.Country[0].Icon
            : "";

        var leadSummary =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].ShortDescription
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].ShortDescription;
        leadSummary =
          leadSummary == null
            ? ""
            : leadSummary.length > 150
            ? `${leadSummary.substr(0, 150)}...`
            : leadSummary;

        var leadKeywords =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Keywords
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Keywords;
        leadKeywords = leadKeywords.split(",");
        var link = element.LinkString;
        this.leadListData.push({
          id: leadId,
          title: leadTitle,
          link: link,
          createTime: createTime,
          countryName: countryName,
          countryCode: countryCode !== null ? countryCode.toLowerCase() : "",
          summary: leadSummary,
          keywords: leadKeywords,
          leadType: leadType,
          credit: credit,
        });
      });
      this.$store.state.isSearchChangedX = false;
      this.showLoader = false;
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    setSelectedMainCategory(id) {
      this.selectedMainCategory = parseInt(id);

      this.getSubCategories();
    },
    setSelectedSubCategory(id) {
      this.selectedSubCategory = parseInt(id);
    },
    setSelectedCountry(id) {
      this.selectedCountry = parseInt(id);
    },
    setSelectedLeadType(id) {
      this.selectedLeadType = parseInt(id);
    },
    clearFilters() {
      this.selectedMainCategory = 0;
      this.selectedSubCategory = 0;
      this.searchText = "";
      this.selectedCountry = 0;
      this.$store.state.searchInputValueX = "";

      this.getLeadsList(0);
    },
    reBuildMainCategories() {
      this.mainCategories = [];
      this.mainCategoriesFullData.forEach((element) => {
        var mainCategoryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;
        if (this.selectedMainAndSubCategories.length > 0) {
          if (
            this.selectedMainAndSubCategories.filter(
              (q) => q.mainCategoryId == mainCategoryId
            ).length > 0
          ) {
            this.mainCategories.push({
              text: name,
              id: mainCategoryId,
            });
          }
        } else {
          this.mainCategories.push({
            text: name,
            id: mainCategoryId,
          });
        }
      });

      this.mainCategories.unshift({
        text: this.$store.getters.getWordLocale("txt_tumu"),
        id: 0,
      });
    },
    reBuildSubCategories() {
      this.subCategories = [];
      this.subCategoriesFullData.forEach((element) => {
        var subCategoryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;

        if (this.selectedMainAndSubCategories.length > 0) {
          if (
            this.selectedMainAndSubCategories.filter(
              (q) => q.categoryId == subCategoryId
            ).length > 0
          ) {
            this.subCategories.push({
              text: name,
              id: subCategoryId,
            });
          }
        } else {
          this.subCategories.push({
            text: name,
            id: subCategoryId,
          });
        }
      });
    },
    reBuildCountries() {
      this.countries = [];
      this.countriesFullData.forEach((element) => {
        var countryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        if (this.selectedCountries.length > 0) {
          if (this.selectedCountries.indexOf(countryId) !== -1) {
            this.countries.push({
              text: name,
              id: parseInt(element._id),
              flag: element.Flag,
            });
          }
        } else {
          this.countries.push({
            text: name,
            id: parseInt(element._id),
            flag: element.Flag,
          });
        }
      });
    },
  },
  created() {
    moment.locale(`${this.$store.state.langCodeX}`);

    if (this.$store.state.searchInputValueX != "") {
      this.searchText = this.$store.state.searchInputValueX;
    }
    // #region Left Side Filter
    this.hasFilterItems =
      this.$store.state.domainContentX.FilterContent.filter(
        (q) =>
          q.id == "2" && parseInt(q.status) == 1
      ).length > 0
        ? true
        : false;

    if (this.hasFilterItems == true) {
      var filterItems = this.$store.state.domainContentX.FilterContent.filter(
        (q) =>
          q.id == "2" && parseInt(q.status) == 1
      )[0].items;

      this.hasCategory =
        filterItems.filter(
          (q) =>
            parseInt(q.id) == 1 && q.status == 1
        ).length > 0;

      this.hasKeywords =
        filterItems.filter(
          (q) =>
            parseInt(q.id) == 3 && q.status == 1
        ).length > 0;
      this.hasCountry =
        filterItems.filter(
          (q) =>
            parseInt(q.id) == 4 && q.status == 1
        ).length > 0;

      this.hasLeadTypes =
        filterItems.filter(
          (q) =>
            parseInt(q.id) == 2 && q.status == 1
        ).length > 0;

      if (
        this.hasCategory == false &&
        this.hasKeywords == false &&
        this.hasCountry == false &&
        this.hasLeadTypes == false
      ) {
        this.hasFilterItems = false;
      }

      if (this.hasCategory) {
        this.getMainCategories();
      }

      if (this.hasCountry) {
        this.getCountries();
      }
    }

    helper.SetSelect2();
    // #endregion

    // #region LeadsFilter
    var keywords = this.leadContent.Keywords;

    var selectedCategories = this.leadContent.SelectedCategories;
    var selectedLeads = this.leadContent.SelectedLeads;
    var selectedCountries = this.leadContent.SelectedCountries;
    this.selectedLeadTypes = this.leadContent.SelectedLeadTypes;
    if (this.selectedLeadTypes.length > 0) {
      var temp = [];
      this.selectedLeadTypes.forEach((element) => {
        var type = parseInt(element);
        temp.push(type);
      });
      this.selectedLeadTypes = [];
      this.selectedLeadTypes = temp;
    }

    if (keywords.length > 0) {
      this.keywords = [];
      keywords.forEach((element) => {
        var text = element.text;
        this.keywords.push(text);
      });
    }

    if (selectedLeads.length > 0) {
      this.selectedLeads = [];
      selectedLeads.forEach((element) => {
        var leadId = parseInt(element.id);
        this.selectedLeads.push(leadId);
      });
    }

    if (selectedCategories.length > 0) {
      this.selectedCategories = [];
      selectedCategories.forEach((element) => {
        var categoryId = parseInt(element.categoryId);
        var mainCategoryId = parseInt(element.mainCategoryId);

        this.selectedCategories.push(categoryId);
        this.selectedMainAndSubCategories.push({
          mainCategoryId: mainCategoryId,
          categoryId: categoryId,
        });
      });
    }

    if (selectedCountries.length > 0) {
      this.selectedCountries = [];
      selectedCountries.forEach((element) => {
        var countryId = parseInt(element);
        this.selectedCountries.push(countryId);
      });
    }

    // #endregion

    this.getLeadsList(0);
  },
};
</script>

<style scoped>
.select2 {
  width: 100% !important;
}

.lead-keywords {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  max-height: 62px;
  overflow: hidden;
}
.lead-keywords span {
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  border-radius: 2px;
  border: solid 1px #dfe5ee;
  height: 26px;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  margin-top: 5px;
  margin-right: 5px;

  font-size: 12px;
}

.lead-card {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  box-shadow: 0 0 8px rgb(0 0 0 / 60%);
}

.lead-card:hover {
  box-shadow: 0 0 8px rgb(0 0 0 / 60%);
}

.lead-country small {
  margin-top: 9px;
  margin-left: 4px;
  font-weight: 900;
}

.separator {
  margin-top: 7px;
  margin-left: 7px;
}

.sell {
  color: #34c5f3 !important;
  border: 1px solid #34c5f3 !important;
  margin-right: 3px;
  font-size: 12px;
  padding: 6px 10px;
}

.buy {
  color: #e71d36 !important;
  border: 1px solid #e71d36 !important;
  font-size: 12px;
  margin-right: 3px;
  padding: 6px 10px;
}

.not-free {
  min-width: 50px;
  text-align: center;
  margin-top: 5px;
  color: #daa520 !important;
  border: 1px solid #daa520 !important;
  font-size: 12px;
  margin-right: 3px;
  padding: 6px 10px;
  height: 31px;
}

.free {
  min-width: 50px;
  text-align: center;
  margin-top: 5px;
  color: #16a448 !important;
  border: 1px solid #16a448 !important;
  font-size: 12px;
  margin-right: 3px;
  padding: 6px 10px;
  height: 31px;
}

a {
  text-decoration: none;
  color: white !important;
}

.lead-time {
  font-weight: 100;
  position: absolute;
  right: -5px;
  box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
}
.page-laoder {
  background: #ffffff96 !important;
}
</style>
